import { useMemo } from 'react';

import useLocale from '../useLocale';
import { getFiles } from './getFiles';

export type SettingsObject = {
    baseUrl: string;
    browseProductsUrl: string;
    currency: string;
    discountsAPI: {
        enableDeliveryOffersAddon: boolean;
        endpoint: string;
    };
    ecoFeeParticipationUrl: string;
    enableAlternativeAvailabilityCheck: boolean;
    enableEnergyLabelLink: boolean;
    isEnhancedMOV: boolean;
    esiBase: string;
    familySignupUrl: string;
    familyUpgradeUrl: string;
    giftRegistryClientId: string;
    giftRegistryEndpoint: string;
    giftRegistryManageUrl: string;
    hideAddToCart: boolean;
    includeVAT: boolean;
    informeraClientId: string;
    informeraEndpoint: string;
    isOmnibusLPPCombined: boolean;
    listClientId: string;
    listEndpoint: string;
    listingFragmentsUrl: string;
    loginUrl: string;
    maxItems: number;
    maxListNameLength: number;
    maxLists: number;
    measurement: 'metric' | 'imperial' | 'both';
    optimizelyBase: string;
    optimizelyKey: string;
    pipUrl: string;
    profileClientId: string;
    profileEndpoint: string;
    publicUrl: string;
    isSetsOfMultiplesEnabled: boolean;
    shareUrl: string;
    showClickAndCollect: boolean;
    showDevModal: boolean;
    showDisplayUnit: boolean;
    showEcoFee: boolean;
    signupUrl: string;
    sunClientId: string;
    sunEnable: boolean;
    sunEndpoint: string;
    sunPrivacyPolicyLink: string;
    urlBaseName: string;
    websiteBase: string;
};

export const useSettings = (): SettingsObject => {
    const localeData = useLocale();
    return useMemo(
        () => getFiles(localeData.ikeaMarketName),
        [localeData.ikeaMarketName]
    );
};
